import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { timeout, catchError } from 'rxjs/operators';
import { SnackBarService } from 'services/snackbar.service';
import { inject, Injector } from '@angular/core';

const TIMEOUT_MS = 9900; // 9.9 seconds

// Interceptor to add a timeout to all HTTP requests, in case BE won't throw an error if a request takes too long
export const timeoutInterceptor: HttpInterceptorFn = (request, next) => {
  const injector = inject(Injector);
  return next(request).pipe(
    timeout(TIMEOUT_MS),
    catchError((err) => {
      if (err.name === 'TimeoutError') {
        const snackBarService = injector.get(SnackBarService);
        snackBarService.popGenericError();
        return throwError(
          () =>
            new HttpErrorResponse({
              error: `Request timed out after ${TIMEOUT_MS} milliseconds`,
              status: 408,
              statusText: 'Request Timeout',
              url: request.url
            })
        );
      }
      return throwError(() => err);
    })
  );
};
